export const LOGO_DHL = 'LOGO_DHL'
export const LOGO_HERMES = 'LOGO_HERMES'
export const LOGO_POSTAT = 'LOGO_POSTAT'
export const LOGO_POINTRELAIS = 'LOGO_MONDIALRELAY'
export const LOGO_COLIS_PRIVE = 'LOGO_COLISPRIVEE'
export const LOGO_COLISSIMO = 'LOGO_LAPOSTE'
export const LOGO_BRT = 'LOGO_BARTOLINI'
export const LOGO_POSTEITALIANE = 'LOGO_POSTEITALIANE'
export const LOGO_DPD = 'LOGO_DPD'
export const LOGO_SWISSPOST_FR = 'LOGO_SWISSPOST_FR'
export const LOGO_SWISSPOST_DE = 'LOGO_SWISSPOST_DE'
